import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { AntStyles, StyledTab } from './Tab.styles.js';
export { StyledTabPane as TabPane } from './Tab.styles.js';
import { useDesignSystemThemeName, cleanProps } from '../utils.js';

var nonNativeProps = ['themeName', 'disableLine', 'regularTabs'];

var Tab = function Tab(props) {
  var className = props.className,
      disableLine = props.disableLine,
      regularTabs = props.regularTabs;
  var themeName = useDesignSystemThemeName();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AntStyles, null), /*#__PURE__*/React__default.createElement(StyledTab, _extends({}, cleanProps(props, nonNativeProps), {
    className: "".concat(className || '', " ").concat(themeName, "\n        ").concat(disableLine && 'tabs-disable-line', " ").concat(regularTabs && 'tabs-regular', " ")
  })));
};

Tab.defaultProps = {
  'data-test-id': 'Tab',
  className: ''
};

export { Tab, Tab as default };
//# sourceMappingURL=Tab.js.map
